export function toUpperCase({target}: {target: EventTarget}) {
  (target as HTMLInputElement).value = (
    target as HTMLInputElement
  ).value.toUpperCase();
}
